import * as nanoid from "nanoid";

export default nanoid.nanoid ? nanoid.nanoid : nanoid;
